import { render, staticRenderFns } from "./SectionCollapseable.vue?vue&type=template&id=3f4dcc98&scoped=true&"
import script from "./SectionCollapseable.vue?vue&type=script&lang=js&"
export * from "./SectionCollapseable.vue?vue&type=script&lang=js&"
import style0 from "./SectionCollapseable.vue?vue&type=style&index=0&id=3f4dcc98&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f4dcc98",
  null
  
)

export default component.exports